import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'

//OWL

export const getReportPivotData = async ({ scenarioId }) => {
  const url = `${BASE_URL}/output/${scenarioId}/reportpivot`
  const response = await synapse.fetch(url)

  return response?.body
}
